@if (data$ | async; as data) {
  <app-alerts />

  <app-warehouse-release-form
    [data]="data"
    [fileUploadVisibility]="fileUploadVisibility()"
    (submitSuccessEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
